
export const  applyThemeColors = (themeData) => {
  let theme;
  const domain = window.location.hostname.split('.')[0];

  if (!themeData) {
    switch (domain) {
      case 'icapidilite-stg':
        case 'pidilite-stg':
        theme = {
          'backdrop-color':'#E7F0F5',
          'navbar-background-color':'#FFFFFF',
          'sidebar-background-color':'#FFFFFF',
          'parent-icon-color': '#000000',
          'parent-font-color': '#000000',
          'parent-active-icon-color': '#D70040',
          'parent-active-font-color': '#D70040',
          'parent-bg-color': '#E7F0F5',
          'child-font-color': '#000000',
          'child-active-font-color':'#D70040',
          'buttonBackGroundColor':'#343b46',
          'buttonTextColor':'#FFFFFF',
          'closeButtonBackGroundColor':'#aaaaaad9',
          'closeButtonTextColor':'#FFFFFF',
          'tableHeadRow-background-color':'#343b46',
          'tableHeadRow-font-color':'#FFFFFF',
          'font-color':'#000000',
          'toggle-icon-color':'#000000',
          'nav-dropdown_partition':'#00000066',
          'activeIconColor': '#DC143C',
        };
        break;
      case 'vguard-bt-stg':
        theme = {
          'backdrop-color':'#FFFFFF',
          'navbar-background-color':'#151718',
          'sidebar-background-color':'#151718',
          'parent-icon-color': '#f9c900',
          'parent-font-color': '#FFFFFF',
          'parent-active-icon-color': '#f9c900',
          'parent-active-font-color': '#f9c900',
          'parent-bg-color': '#151718',
          'child-font-color': '#FFFFFF',
          'child-active-font-color':'#f9c900',
          'buttonBackGroundColor':'#f9c900',
          'buttonTextColor':'#151718',
          'closeButtonBackGroundColor':'#aaaaaad9',
          'closeButtonTextColor':'#151718',
          'tableHeadRow-background-color':'#f9c900',
          'tableHeadRow-font-color':'#151718',
          'font-color':'#FFFFFF',
          'toggle-icon-color':'#f9c900',
          'nav-dropdown_partition':'#FFFFFF',
          'activeIconColor': '#f9c900',
        };
        break;
      case 'boat-stg':
        theme = {
          'backdrop-color':'#E7F0F5',
          'navbar-background-color':'#FFFFFF',
          'sidebar-background-color':'#FFFFFF',
          'parent-icon-color': '#FF0000',
          'parent-font-color': '#151718',
          'parent-active-icon-color': '#FF0000',
          'parent-active-font-color': '#FF0000',
          'parent-bg-color': '#E7F0F5',
          'child-font-color': '#151718',
          'child-active-font-color':'#FF0000',
          'buttonBackGroundColor':'#FF0000',
          'buttonTextColor':'#FFFFFF',
          'closeButtonBackGroundColor':'#aaaaaad9',
          'closeButtonTextColor':'#FFFFFF',
          'tableHeadRow-background-color':'#FF0000',
          'tableHeadRow-font-color':'#FFFFFF',
          'font-color':'#151718',
          'toggle-icon-color':'#FF0000',
          'nav-dropdown_partition':'#00000066',
          'activeIconColor': '#FF0000',
        };
        break;
        case 'crompton-stg':
        case 'mango-stg':
        theme = {
          'backdrop-color':'#E7F0F5',
          'navbar-background-color':'#FFFFFF',
          'sidebar-background-color':'#FFFFFF',
          'parent-icon-color': '#08558C',
          'parent-font-color': '#151718',
          'parent-active-icon-color': '#FFFFFF',
          'parent-active-font-color': '#FFFFFF',
          'parent-bg-color': '#08558C',
          'child-font-color': '#151718',
          'child-active-font-color':'#08558C',
          'buttonBackGroundColor':'#08558C',
          'buttonTextColor':'#FFFFFF',
          'closeButtonBackGroundColor':'#aaaaaad9',
          'closeButtonTextColor':'#FFFFFF',
          'tableHeadRow-background-color':'#08558C',
          'tableHeadRow-font-color':'#FFFFFF',
          'font-color':'#151718',
          'toggle-icon-color':'#08558C',
          'nav-dropdown_partition':'#00000066',
          'activeIconColor': '#08558C',
        };
        break;
      default:
        theme = {
          'backdrop-color':'#E7F0F5',
          'navbar-background-color':'#FFFFFF',
          'sidebar-background-color':'#FFFFFF',
          'parent-icon-color': '#08558C',
          'parent-font-color': '#151718',
          'parent-active-icon-color': '#FFFFFF',
          'parent-active-font-color': '#FFFFFF',
          'parent-bg-color': '#08558C',
          'child-font-color': '#151718',
          'child-active-font-color':'#08558C',
          'buttonBackGroundColor':'#08558C',
          'buttonTextColor':'#FFFFFF',
          'closeButtonBackGroundColor':'#aaaaaad9',
          'closeButtonTextColor':'#FFFFFF',
          'tableHeadRow-background-color':'#08558C',
          'tableHeadRow-font-color':'#FFFFFF',
          'font-color':'#151718',
          'toggle-icon-color':'#08558C',
          'nav-dropdown_partition':'#00000066',
          'activeIconColor': '#08558C',
        };
        break;
    }
  } else {
    theme = themeData;
  }

  document.documentElement.style.setProperty('--backdrop-color', theme['backdrop-color']);
  document.documentElement.style.setProperty('--navbar-background-color', theme['navbar-background-color']);
  document.documentElement.style.setProperty('--sidebar-background-color', theme['sidebar-background-color']);
  document.documentElement.style.setProperty('--parent-icon-color', theme['parent-icon-color']);
  document.documentElement.style.setProperty('--parent-font-color', theme['parent-font-color']);
  document.documentElement.style.setProperty('--parent-active-icon-color', theme['parent-active-icon-color']);
  document.documentElement.style.setProperty('--parent-active-font-color', theme['parent-active-font-color']);
  document.documentElement.style.setProperty('--parent-bg-color', theme['parent-bg-color']);
  document.documentElement.style.setProperty('--child-font-color', theme['child-font-color']);
  document.documentElement.style.setProperty('--child-active-font-color', theme['child-active-font-color']);
  document.documentElement.style.setProperty('--tableHeadRow-background-color', theme['tableHeadRow-background-color']);
  document.documentElement.style.setProperty('--tableHeadRow-font-color', theme['tableHeadRow-font-color']);
  document.documentElement.style.setProperty('--toggle-icon-color', theme['toggle-icon-color']);
  document.documentElement.style.setProperty('--nav-dropdown_partition', theme['nav-dropdown_partition']);
  document.documentElement.style.setProperty('--font-color', theme['font-color']);

  document.documentElement.style.setProperty('--active__icon-color', theme.activeIconColor);
  document.documentElement.style.setProperty('--button_background-color', theme.buttonBackGroundColor);
  document.documentElement.style.setProperty('--button_text-color', theme.buttonTextColor);
  document.documentElement.style.setProperty('--close-button_background-color', theme.closeButtonBackGroundColor);
  document.documentElement.style.setProperty('--close-button_text-color', theme.closeButtonTextColor);
}

export const getThemeColorsFromResponse = (response) => {
  return response?.themeColors || null;
};